import { t } from '../i18n';
import type { NewsListItem } from '../api';

export function newsListField(list: NewsListItem, field: 'name' | 'descr'): string {
  const key = `subs.list.${list.listid}.${field}`;
  const translated = t(key);
  if (translated !== key) return translated;
  return field === 'name' ? list.name : (list.descr ?? '');
}
